import { createApi } from '@reduxjs/toolkit/query/react';
import { urls } from '../../utils/helpers/ApiClient';
import axiosFetchBase from '../axiosFetchBase';

export const erasmusMobilitySubtypesApi = createApi({
  reducerPath: 'erasmusMobilitySubtypesApi',
  keepUnusedDataFor: 0,
  baseQuery: axiosFetchBase,
  endpoints: (builder) => ({
    getErasmusMobilitySubtypes: builder.query({
      query: (isEnglish = false) => {
        return {
          url: urls.erasmusMobilitySubtypes,
        };
      },
    }),
    getErasmusMobilitySubtype: builder.query({
      query: (id) => ({
        url: urls.erasmusMobilitySubtypeDetail(id),
      }),
    }),
    saveErasmusMobilitySubtype: builder.mutation({
      query(req) {
        if (req.id) {
          return {
            url: urls.erasmusMobilitySubtypeDetail(req.id),
            method: 'PUT',
            data: req.body,
          };
        } else {
          return {
            url: urls.erasmusMobilitySubtypes,
            method: 'POST',
            data: req.body,
          };
        }
      },
    }),
    deleteErasmusMobilitySubtype: builder.mutation({
      query(id) {
        return {
          url: urls.erasmusMobilitySubtypeDetail(id),
          method: 'DELETE',
        };
      },
    }),
  }),
});

export const {
  useGetErasmusMobilitySubtypesQuery,
  useGetErasmusMobilitySubtypeQuery,
  useSaveErasmusMobilitySubtypeMutation,
  useDeleteErasmusMobilitySubtypeMutation,
} = erasmusMobilitySubtypesApi;
